'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var common_1 = require("./common");
//import Calc from './calc';
$(function () {
    // コモン
    var COMMON = new common_1.default.MyCommon();
});
